export default "__VITE_ASSET__ChrU2Ovs__"